import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=2d6e5d6b&"
import script from "./ModalItem.vue?vue&type=script&lang=js&"
export * from "./ModalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports